import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Loading } from 'react-vant'
import Header from '@/components/Header'
import Back from '@/components/Back'

export default function About() {
    const { t, i18n } = useTranslation()
    const currentLang = i18n.language
    const isZhCN = currentLang === 'zh-CN'
    const [loading, setLoading] = useState(true)

    const handleIframeLoad = () => {
        setLoading(false)
    }

    return (
        <div className='fixed top-0 left-0 w-full h-full bg-white' style={{ overflow: 'hidden' }}>
            <div className='absolute top-0 left-0 w-full' style={{ height: '3.5rem', zIndex: 100 }}>
                <Header
                    leftChildren={<Back />}
                    centerChildren={<span className='text-3.75 font-medium text-black'>{t('关于我们')}</span>}
                />
            </div>
            {loading && (
                <div 
                    className='absolute flex items-center justify-center bg-white' 
                    style={{
                        top: '3.5rem',
                        left: 0,
                        right: 0,
                        bottom: 0,
                        zIndex: 50
                    }}
                >
                    <Loading size="24px" type="ball"></Loading>
                </div>
            )}
            <iframe 
                className='absolute border-none block' 
                style={{
                    top: '3.5rem',
                    left: 0,
                    right: 0,
                    bottom: 0,
                    width: '100%',
                    height: 'calc(100% - 3.5rem)',
                    border: 'none',
                    display: 'block'
                }}
                src={isZhCN ? "https://gitbook.wpay.ai/wpay-bai-pi-shu/" : "https://gitbook.wpay.ai/wpay-white-paper/"}
                onLoad={handleIframeLoad}
                scrolling="yes"
                sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-pointer-lock"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                referrerPolicy="no-referrer-when-downgrade"
                title={t('关于我们')}
            />
        </div>
    )
}